var angularModule = angular.module('t2g.common.directives.intInput', []);

module.exports = angularModule;

angularModule.directive('intInput', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            min: '=',
            max: '=',
        },
        link: function ($scope, $element, $attributes, $ngModelController) {
            $ngModelController.$parsers.push(function (inputValue) {
                var transformedInput = inputValue.replace(/[^0-9]+/g, '');

                if (transformedInput != inputValue) {
                    $ngModelController.$setViewValue(transformedInput);
                    $ngModelController.$render();
                }

                if ($scope.max && transformedInput && parseInt(transformedInput) > parseInt($scope.max)) {
                    transformedInput = $scope.max.toString();
                    $ngModelController.$setViewValue(transformedInput);
                    $ngModelController.$render();
                }

                return transformedInput;
            });

        }
    }
});



